require('./bootstrap');

require('./swal');
require('./resize');
require('./pageLoad');
